<section class="testimonials">
    <div class="testimonials-content">
        <div class="text-content col-12 md:col-3">
            <h2 class="text-left">Don't just take our word for it.</h2>
            <p  class="text-left">Hear firsthand from real customers who have saved hundreds of dollars on their trips.</p>
            <button *ngIf="!viewport.isMobile" pButton severity="secondary" [outlined]="true" [rounded]="true" [routerLink]="[]" fragment="signup-logo" class="font-bold">{{partner?.btnHome}} →</button>
        </div>
        <div class="md:col-9 testimonials-container container">
            <p-carousel [value]="testimonials" [numVisible]="numVisible" [numScroll]="1" [circular]="false" [styleClass]="'force-active'" [showIndicators]="false">
                <ng-template let-testimonial pTemplate="item">
                    <div class="testimonial">
                        <div class="video-thumbnail">
                            <video
                                #myVideo
                                [id]="'video-' + testimonial.name"
                                [src]="testimonial.video"
                                controls
                                preload="none"
                                class="testimonial-video"
                            ></video>

                            <div class="video-overlay" *ngIf="playingVideoTestimonial !== testimonial" (click)="playVideo(testimonial, myVideo, $event)">
                                <img [src]="testimonial.image" [alt]="testimonial.name" loading="lazy"/>
                                <div class="play-button">
                                    <i class="pi pi-play"></i>
                                </div>
                            </div>
                        </div>
                        <div class="testimonial-text">
                            <p class="join-year">Joined {{ testimonial.year }}</p>
                            <p class="testimonial-quote">“{{ testimonial.text }}”</p>
                            <span class="testimonial-name">{{ testimonial.name }}</span>
                        </div>
                    </div>
                </ng-template>
            </p-carousel>



        </div>
    </div>
</section>
